<pcg-header id="mainTopHeader"></pcg-header>
<pcg-push-notification></pcg-push-notification>
<div role="main" class="main-container">
	<!--
		<pcg-side-nav></pcg-side-nav>
	-->
	<div class="container p-2">
		<router-outlet></router-outlet>
	</div>
</div>
<pcg-system-message></pcg-system-message>
<pcg-spinner></pcg-spinner>
